
import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const assetsConstants = {
  POST_ASSETS_LIST_START: "POST_ASSETS_LIST_START",
  POST_ASSETS_LIST_SUCCESS: "POST_ASSETS_LIST_SUCCESS",
  POST_ASSETS_LIST_ERROR: "POST_ASSETS_LIST_ERROR",

  GET_ASSETS_LIST_START: "GET_ASSETS_LIST_START",
  GET_ASSETS_LIST_SUCCESS: "GET_ASSETS_LIST_SUCCESS",
  GET_ASSETS_LIST_ERROR: "GET_ASSETS_LIST_ERROR",

  GET_ASSET_START: "GET_ASSET_START",
  GET_ASSET_SUCCESS: "GET_ASSET_SUCCESS",
  GET_ASSET_ERROR: "GET_ASSET_ERROR",

  GET_UPDATED_ASSET_START: "GET_UPDATED_ASSET_START",
  GET_UPDATED_ASSET_SUCCESS: "GET_UPDATED_ASSET_SUCCESS",
  GET_UPDATED_ASSET_ERROR: "GET_UPDATED_ASSET_ERROR",

  GET_FIXED_ASSETS_LIST_START: "GET_FIXED_ASSETS_LIST_START",
  GET_FIXED_ASSETS_LIST_SUCCESS: "GET_FIXED_ASSETS_LIST_SUCCESS",
  GET_FIXED_ASSETS_LIST_ERROR: "GET_FIXED_ASSETS_LIST_ERROR",

  GET_FIXED_ASSETS_DETAILS_START: "GET_FIXED_ASSETS_DETAILS_START",
  GET_FIXED_ASSETS_DETAILS_SUCCESS: "GET_FIXED_ASSETS_DETAILS_SUCCESS",
  GET_FIXED_ASSETS_DETAILS_ERROR: "GET_FIXED_ASSETS_DETAILS_ERROR",

  GET_FIXED_ASSETS_DETAILS_LOGS_START: "GET_FIXED_ASSETS_DETAILS_LOGS_START",
  GET_FIXED_ASSETS_DETAILS_LOGS_SUCCESS: "GET_FIXED_ASSETS_DETAILS_LOGS_SUCCESS",
  GET_FIXED_ASSETS_DETAILS_LOGS_ERROR: "GET_FIXED_ASSETS_DETAILS_LOGS_ERROR",

  PATCH_FIXED_ASSETS_START: "PATCH_FIXED_ASSETS_START",
  PATCH_FIXED_ASSETS_SUCCESS: "PATCH_FIXED_ASSETS_SUCCESS",
  PATCH_FIXED_ASSETS_ERROR: "PATCH_FIXED_ASSETS_ERROR",

  GET_ASSET_SELECTED_START: "GET_ASSET_SELECTED_START",
  GET_ASSET_SELECTED_SUCCESS: "GET_ASSET_SELECTED_SUCCESS",
  GET_ASSET_SELECTED_ERROR: "GET_ASSET_SELECTED_ERROR",

  POST_SIMULATE_ASSET_SELL_START: "POST_SIMULATE_ASSET_SELL_START",
  POST_SIMULATE_ASSET_SELL_SUCCESS: "POST_SIMULATE_ASSET_SELL_SUCCESS",
  POST_SIMULATE_ASSET_SELL_ERROR: "POST_SIMULATE_ASSET_SELL_ERROR",

  POST_ASSET_SELL_START: "POST_ASSET_SELL_START",
  POST_ASSET_SELL_SUCCESS: "POST_ASSET_SELL_SUCCESS",
  POST_ASSET_SELL_ERROR: "POST_ASSET_SELL_ERROR",

  GET_ASSET_SUBKIND_LIST_START: "GET_ASSET_SUBKIND_LIST_START",
  GET_ASSET_SUBKIND_LIST_SUCCESS: "GET_ASSET_SUBKIND_LIST_SUCCESS",
  GET_ASSET_SUBKIND_LIST_ERROR: "GET_ASSET_SUBKIND_LIST_ERROR",

  GET_DEPRECIATION_ASSET_RATES_START: "GET_DEPRECIATION_ASSET_RATES_START",
  GET_DEPRECIATION_ASSET_RATES_SUCCESS: "GET_DEPRECIATION_ASSET_RATES_SUCCESS",
  GET_DEPRECIATION_ASSET_RATES_ERROR: "GET_DEPRECIATION_ASSET_RATES_ERROR",
  GET_DEPRECIATION_ASSET_RATES_RESET: "GET_DEPRECIATION_ASSET_RATES_RESET",

  DELETE_ASSET_GROUP_START: "DELETE_ASSET_GROUP_START",
  DELETE_ASSET_GROUP_SUCCESS: "DELETE_ASSET_GROUP_SUCCESS",
  DELETE_ASSET_GROUP_ERROR: "DELETE_ASSET_GROUP_ERROR",

  GET_ASSET_LOG_SEQUENCE_START: "GET_ASSET_LOG_SEQUENCE_START",
  GET_ASSET_LOG_SEQUENCE_SUCCESS: "GET_ASSET_LOG_SEQUENCE_SUCCESS",
  GET_ASSET_LOG_SEQUENCE_ERROR: "GET_ASSET_LOG_SEQUENCE_ERROR"
};

export function postAssetsList(groupBy) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = getState().precog.invoiceDetail.data.id;
    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.POST_ASSETS_LIST_START
      });

      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: { groupBy: groupBy }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.POST_ASSETS_LIST_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.POST_ASSETS_LIST_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getAssetsList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = getState().precog.invoiceDetail.data.id;
    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_ASSETS_LIST_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_ASSETS_LIST_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_ASSETS_LIST_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getAsset(assetId, _draftId = null) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = _draftId ? _draftId : getState().precog.invoiceDetail.data.id;
    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_ASSET_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset/${assetId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_ASSET_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_ASSET_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getSubkindList(group, kind) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_ASSET_SUBKIND_LIST_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/asset/groups/${group}/kinds/${kind}/subkinds`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_ASSET_SUBKIND_LIST_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_ASSET_SUBKIND_LIST_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
}

export function updatedAsset(assetId, newAsset) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = getState().precog.invoiceDetail.data.id;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset/${assetId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: newAsset
      };

      dispatch({
        type: assetsConstants.GET_UPDATED_ASSET_START,
        payload: { assetId, newAsset }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: assetsConstants.GET_UPDATED_ASSET_SUCCESS,
              updatedData: {
                assetId: assetId,
                newAsset: newAsset
              },
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: assetsConstants.GET_UPDATED_ASSET_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: assetsConstants.GET_UPDATED_ASSET_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getAssetSelected(assetId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = getState().precog.invoiceDetail.data.id;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset/${assetId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: assetsConstants.GET_ASSET_SELECTED_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: assetsConstants.GET_ASSET_SELECTED_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: assetsConstants.GET_ASSET_SELECTED_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: assetsConstants.GET_ASSET_SELECTED_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

// DEPRECATED
// export function getFixedAssetsList(businessId=null, filters = null) {
//   return (dispatch, getState) => {
//     const auth = getState().auth;
//     const managerId = getState().main.accountantUuidSelected;
//     const itemId = getState().main.companyUuidSelected;

//     return new Promise((resolve, reject) => {
//       dispatch({
//         type: assetsConstants.GET_FIXED_ASSETS_LIST_START
//       });
//       let params = "";
//       for (let f in filters) {
//         if (filters[f]) params += `&${f}=${filters[f]}`;
//       }

//       let request = {
//         method: "GET",
//         url: `${API_PDC_URL_V1}/asset?${businessId ? "businessId="+ businessId + "&" : ""}managerId=${managerId}&itemId=${itemId}${params}&page=0&size=10`,
//         headers: {
//           ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
//         }
//       };

//       callWithRetry(
//         auth, request, dispatch
//       )
//         .then((result) => {
//           dispatch({
//             type: assetsConstants.GET_FIXED_ASSETS_LIST_SUCCESS,
//             payload: {
//               data: result.data
//             }
//           });
//           resolve(result.data);
//         })
//         .catch((err) => {
//           dispatch({
//             type: assetsConstants.GET_FIXED_ASSETS_LIST_ERROR,
//             payload: err
//           });
//         });
//     });
//   };
// }

export function getFixedAssetsList(
  businessId=null, filters = null, nextUrl
) {
  
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_FIXED_ASSETS_LIST_START
      });
      let params = "";
      for (let f in filters) {
        if (filters[f]) params += `&${f}=${filters[f]}`;
      }

      let request = {
        method: "GET",
        url: nextUrl ? nextUrl : API_PRECOG_URL_V1 + `/asset?${businessId ? "businessId="+ businessId + "&" : ""}managerId=${managerId}&itemId=${itemId}${params}&page=0&size=10`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_LIST_SUCCESS,
            payload: {...result, toAdded: nextUrl ? true : false}
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_LIST_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getFixedAssetDetails(assetId, businessId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_FIXED_ASSETS_DETAILS_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/asset/${assetId}?managerId=${managerId}&itemId=${itemId}&businessId=${businessId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_DETAILS_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_DETAILS_ERROR,
            payload: err
          });
        });
    });
  };
}

export function assetRevaluation(
  assetId, businessId, dataToSent
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {      
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/asset/${assetId}/revaluate?managerId=${managerId}&itemId=${itemId}&businessId=${businessId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: dataToSent
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {          
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export function assetSimulationRevaluation(
  assetId, businessId, dataToSent
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {      
      let request = {
        method: "POST",
        
        url: `${API_PRECOG_URL_V1}/asset/${assetId}/simulation/revaluate?managerId=${managerId}&itemId=${itemId}&businessId=${businessId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: dataToSent
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {          
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export function getFixedAssetDetailsLogs(
  assetId, businessId, activeFilter
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_FIXED_ASSETS_DETAILS_LOGS_START
      });

      const baseUrl = `${API_PRECOG_URL_V1}/asset/${assetId}/logs?managerId=${managerId}&itemId=${itemId}&businessId=${businessId}`;

      let request = {
        method: "GET",
        url: activeFilter === null ? baseUrl : `${baseUrl}&type=${activeFilter}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_DETAILS_LOGS_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_FIXED_ASSETS_DETAILS_LOGS_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getFixedAssetLogsSequence(
  assetId, businessId, sequence
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_ASSET_LOG_SEQUENCE_START
      });

      const url = `${API_PRECOG_URL_V1}/asset/${assetId}/logs/sequence?managerId=${managerId}&itemId=${itemId}&businessId=${businessId}&sequence=${sequence}`;

      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_ASSET_LOG_SEQUENCE_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((error) => {
          dispatch({
            type: assetsConstants.GET_ASSET_LOG_SEQUENCE_ERROR,
            payload: error
          });
          reject(error);
        });
    });
  };
}

export function simulationAssetSell(assetId, data) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.POST_SIMULATE_ASSET_SELL_START,
        payload: {
          assetId,
          data
        }
      });

      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/asset/${assetId}/simulation/sell?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: data
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.POST_SIMULATE_ASSET_SELL_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.POST_SIMULATE_ASSET_SELL_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
}

export function assetSell(assetId, data) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.POST_ASSET_SELL_START,
        payload: {
          assetId, data
        }
      });

      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/asset/${assetId}/sell/?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: data
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.POST_ASSET_SELL_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((error) => {
          dispatch({
            type: assetsConstants.POST_ASSET_SELL_ERROR,
            payload: error
          });
          reject(error);
        });
    });
  };
}

export function resetGetDepreciationAssetRates() {
  dispatch({
    type: assetsConstants.GET_DEPRECIATION_ASSET_RATES_RESET
  });
}

export function getDepreciationAssetRates(
  groupId, kindId, subKindId
) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise((resolve, reject) => {
      dispatch({
        type: assetsConstants.GET_DEPRECIATION_ASSET_RATES_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/asset/group/${groupId}/kind/${kindId}/subKind/${subKindId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: assetsConstants.GET_DEPRECIATION_ASSET_RATES_SUCCESS,
            payload: {
              ...result.data
            }
          });
        })
        .catch((err) => {
          dispatch({
            type: assetsConstants.GET_DEPRECIATION_ASSET_RATES_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getDeductibilityGoods(accountCode) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected; 

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",        
        url: `${API_PRECOG_URL_V1}/asset/deductibilityGoods?itemId=${itemId}&managerId=${managerId}&accountCode=${accountCode}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {           
            resolve(result.data);
          } else {
           
            reject();
          }
        })
        .catch((response) => {          
          reject(response);
        });
    });
  };
}

export function createAssetGroup(assetIds) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected; 
    const draftId = getState().precog.invoiceDetail.data.id;
   
    return new Promise((resolve, reject) => {

      let request = {
        method: "POST",        
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset/group?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: { assetGroupIds: assetIds }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export function deleteAssetGroup(parentId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected; 
    const draftId = getState().precog.invoiceDetail.data.id;
    
    return new Promise((resolve, reject) => {
      
      let request = {
        method: "DELETE",        
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/asset/group/${parentId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }       
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}
